/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

/**
 * Enum for the status of a rental
 */
export enum RentalStatusEnum {
  /**
   * The rental is still in draft state and not yet submitted
   */
  DRAFT = "DRAFT",

  /**
   * The rental has been requested but not yet confirmed by the rental provider
   */
  REQUESTED = "REQUESTED",

  /**
   * The rental request has been confirmed by the rental provider
   */
  CONFIRMED = "CONFIRMED",

  /**
   * The rental is currently active (vehicle is being used)
   */
  ACTIVE = "ACTIVE",

  /**
   * The rental has been completed (vehicle has been returned)
   */
  COMPLETED = "COMPLETED",

  /**
   * The rental has been cancelled
   */
  CANCELLED = "CANCELLED"
}
